<template>

  <div>
    <PageTitle
      :route="$route"
    />

    <PageRowWrapper>
      <ServiceTypeForm />
    </PageRowWrapper>
  </div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ServiceTypeForm from '@/components/settings/parameters/serviceTypes/ServiceTypeForm'

export default {
  name: 'ServiceType',
  components: {
    PageTitle,
    PageRowWrapper,
    ServiceTypeForm
  }
}
</script>
